import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

/**
 * Event is fired after successful bankID registration.
 * @memberOf Playtech.API.events
 * @event bankID-auth-register-success
 * @example Playtech.on('bankID-auth-register-success', () => {
 *     // ...
 * });
 */
export const BANK_ID_AUTH_REGISTER_SUCCESS = 'bankID-auth-register-success';

export const useOnBankIDAuthRegisterSuccess = (eventTarget) => {
    const triggerBankIDAuthRegisterSuccessEvent = useCallback((...component) => {
        const popupClosed = new CustomEvent(BANK_ID_AUTH_REGISTER_SUCCESS, { detail: component });

        eventTarget.dispatchEvent(popupClosed);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on(BANK_ID_AUTH_REGISTER_SUCCESS, triggerBankIDAuthRegisterSuccessEvent);

        return () => {
            publicEventsAPIService.off(BANK_ID_AUTH_REGISTER_SUCCESS, triggerBankIDAuthRegisterSuccessEvent);
        };
    }, [triggerBankIDAuthRegisterSuccessEvent]);
};
